/**
 * Setup webpack public path
 * to enable lazy-including of
 * js chunks
 *
 */
/* global urls:true */
import * as bootstrap from 'bootstrap';
import $ from 'jquery';
import flatpickr from 'flatpickr';
import moment from "moment";
import TableSort from "tablesort";
import 'waypoints/lib/noframework.waypoints';
import Sortable from 'sortablejs';

import './scripts/email-dockets';
import './scripts/vehicle-registrations';
import './scripts/respond-to-job';
import './scripts/facility-jobs';
import './scripts/multiple-locations';
import './scripts/rate-for-dropdown';
// import './scripts/confirm-requires-dockets';
import api from "./scripts/ajax";
import debounce from './utils/debounce';
import jobSubContractors from "./scripts/job-subcontractors";
import renderAddSubContractorRows from "./scripts/render-add-sub-contractor-row";
import sendMessageToAutoComplete from "./scripts/send-message-to-autocomplete";
import sendMessage from "./scripts/send-message";
import emailDockets from "./scripts/email-dockets";
import SubContractorsTableSort from "./scripts/sub-contractors-table-sort";
import RemoveTipping from "./scripts/remove-tipping";
import AdditionalTipping from "./scripts/additional-tipping";
import NDD from "./scripts/ndd";
import Gallery from "./scripts/gallery";

window.jQuery = $;
window.$ = $;

$(() => {
	jobSubContractors();

	sendMessageToAutoComplete();

	sendMessage();

	emailDockets();

	SubContractorsTableSort();

	AdditionalTipping();

	NDD();

	RemoveTipping();

	Gallery();

	const forms = document.querySelectorAll('.needs-validation');

	const changeDate = (showJobsForDate) => {
		const url = $('#dayIncrementer').data('url');
		const filterTracked = $('#dayIncrementer').data('filter-tracked');

		// Create a new URL object from the url
		let redirectTo = new URL(url, window.location.origin);

		// If date exists in the URL, update it; otherwise, add it
		redirectTo.searchParams.set('date', showJobsForDate);

		// If filterTracked is true, set 'tracked' to true
		if (filterTracked && JSON.parse(filterTracked)) {
			redirectTo.searchParams.set('tracked', true);
		}

		// Update the URL
		window.location.href = redirectTo.href;
	};

	const stepDate = (step) => {
		const showJobsForDate = moment($('#dayIncrementer').data('date'), 'YYYY-MM-DD');

		step > 0 ? showJobsForDate.add(step, 'days') : showJobsForDate.subtract(Math.abs(step), 'days');

		// console.log(showJobsForDate);

		return showJobsForDate;
	};

	// Loop over them and prevent submission
	Array.prototype.slice.call(forms)
		.forEach(function (form) {
			$(form).children().on('change keyup', debounce((e) => {
				$(form).find(':submit').attr('disabled', !form.checkValidity());
			}));

			form.addEventListener('submit', function (event) {
				if (!form.checkValidity()) {
					event.preventDefault()
					event.stopPropagation()
				}

				form.classList.add('was-validated');
			}, false)
		});

	// Init Datepicker on Job filter by date
	flatpickr('#selectJobsForDate', {
		allowInput: true,
		dateFormat: 'Y-m-d',
		altFormat: 'd/m/Y',
		altInput: true,
		onChange: (selectedDates, dateStr) => {
			changeDate(dateStr);
		}
	});

	flatpickr('#id_job_date', {
		allowInput: true,
		dateFormat: 'Y-m-d',
		altFormat: 'd/m/Y',
		altInput: true
	});

	// Time input
	const meridiemVal = $('#timeInput input[name=job_time_meridiem]').val();

	if (meridiemVal === 'AM') {
		$('#timeInput .meridiem .btn.am').addClass('active')
	}

	if (meridiemVal === 'PM') {
		$('#timeInput .meridiem .btn.pm').addClass('active')
	}


	$('#timeInput .meridiem .btn').on('click', (e) => {
		const {currentTarget} = e;
		$('#timeInput .meridiem .btn').removeClass('active');
		$(currentTarget).addClass('active');
		$('#timeInput input[name=job_time_meridiem]').val($(currentTarget).val());
	});

	$('#timeInput input[type=number]').on('change', (e) => {
		const {currentTarget} = e;
		const field = $(currentTarget);
		const val = field.val();

		if (val < 10) {
			field.val(`0${val}`);
		}
	});


	// Disposal input
	const disposalVal = $('#disposal').val();

	if (disposalVal === 'True') {
		$('#disposalToggle .btn.true').addClass('active');
	}

	if (disposalVal === 'False') {
		$('#disposalToggle .btn.false').addClass('active');
		$('#disposalAddress').collapse('show');
	}

	$('#disposalToggle .btn').on('click', (e) => {
		const {currentTarget} = e;
		const val = $(currentTarget).val().toLowerCase();
		const collapse = val === 'true' || val === true ? 'hide' : 'show';

		$('#disposalToggle .btn').removeClass('active');
		$(currentTarget).addClass('active');
		$('#disposalToggle input[name=disposal_on_site]').val(val);
		$('#disposalAddress').collapse(collapse);
	});

	// Submit Job form on button click
	$('#saveJob, #actionSaveJob').on('click', () => {
		$('#jobForm').submit();
	});

	// Driver Type buttons
	const driverTypeVal = $('#driverType').val();

	if (driverTypeVal === 'SC') {
		$('#driverTypeToggle .btn.sc').addClass('active');
	}

	if (driverTypeVal === 'SD') {
		$('#driverTypeToggle .btn.sd').addClass('active');
	}

	$('#driverTypeToggle .btn').on('click', (e) => {
		const {currentTarget} = e;
		const val = $(currentTarget).val();

		$('#driverTypeToggle .btn').removeClass('active');
		$(currentTarget).addClass('active');
		$('#driverTypeToggle input[name=driver_type]').val(val);
	});

	$('#saveContractor').on('click', () => {
		$('#contractorCreateForm').submit();
	});

	const subContractorTable = document.getElementById('subContractorTable');

	if (subContractorTable) {
		new TableSort(subContractorTable, {
			descending: true
		});
	}


	// Delete contractor Modal
	const deleteContractorModal = document.getElementById('confirmDeleteModal');

	if (deleteContractorModal) {
		deleteContractorModal.addEventListener('show.bs.modal', (e) => {
			const button = $(e.relatedTarget);
			const modal = $(e.currentTarget);
			const contractorName = button.data('name');
			const contractorId = button.data('id');
			const form = $(modal.find('form')[0]);
			const action = form.data('base-url').replace('-1', contractorId);

			form.attr('action', action);
			modal.find('.contact-name').html(contractorName);

		});
	}

	// Delete job Modal
	const deleteJobModal = document.getElementById('confirmDeleteJobModal');

	if (deleteJobModal) {
		deleteJobModal.addEventListener('show.bs.modal', (e) => {
			const button = $(e.relatedTarget);
			const modal = $(e.currentTarget);
			const jobNumber = button.data('job-no');
			const jobId = button.data('id');
			const form = $(modal.find('form')[0]);
			const action = form.data('base-url').replace('-1', jobId);

			form.attr('action', action);
			modal.find('.job-number').html(jobNumber);

		});
	}

	// Day incrementer
	$('#dayIncrementer').on('click', '.next', (e) => {
		const newDate = stepDate(1);
		changeDate(newDate.format('YYYY-MM-DD'));
	});

	$('#dayIncrementer').on('click', '.prev', (e) => {
		const newDate = stepDate(-1);
		changeDate(newDate.format('YYYY-MM-DD'));
	});

	$('#searchJobs').on('blur keyup', (e) => {
		if (e.type === 'blur' || e.keyCode === 13) {
			const {currentTarget} = e;
			const search = $(currentTarget).val();
			const url = $(currentTarget).data('url');
			const filterTracked = $('#searchJobs').data('filter-tracked');

			let redirectUrl = `${url}?s=${search}`;

			if (filterTracked && JSON.parse(filterTracked)) {
				redirectUrl += '&tracked=true';
			}

			window.location = redirectUrl;
		}
	});

	$('#searchContractors').on('blur keyup', (e) => {
		if (e.keyCode === 13) {
			const {currentTarget} = e;
			const search = $(currentTarget).val();

			const url = $(currentTarget).data('url');
			window.location = `${url}?s=${search}`;
		}
	});

	$('#searchContractorsModal').on('blur keyup', async (e) => {
		const {currentTarget} = e;
		const search = $(currentTarget).val();
		const jobDate = $('#jobDate input').val();
		const jobId = $(currentTarget).data('job-id');

		// Make Ajax request
		const response = await api.getSubContractorsByName(search, jobDate, this);

		if (!response.error) {
			const {body: subContractors} = response;

			const html = renderAddSubContractorRows(subContractors, jobId);

			$('#subContractorTable tbody').html(html);
		}
	});

	$('#jobs').on('click', '.duplicate', (e) => {
		const {currentTarget} = e;
		const duplicateId = $(currentTarget).data('id');
		const jobDate = $(currentTarget).data('date');
		const createJobForm = $('#createJobForm');

		console.log(jobDate);

		createJobForm.children('input[name=clone]').val(duplicateId);
		createJobForm.children('input[name=date]').val(jobDate);

		createJobForm.submit();
	});

	// Toggle Reminders on Job
	$('.setJobReminders').on('click', async (e) => {
		const { currentTarget } = e;
		const currentStatus = $(currentTarget).data('status');
		const jobId = $(currentTarget).data('id');

		const response = await api.setJobReminders(jobId, !currentStatus, this);

		if (!response.error) {
			const { body: { send_docket_reminders} } = response;

			$(currentTarget).data('status', send_docket_reminders);

			if (send_docket_reminders) {
				$(currentTarget).addClass('job-status--ready');
				$(currentTarget).children('span').html("ON");
			} else {
				$(currentTarget).removeClass('job-status--ready');
				$(currentTarget).children('span').html("OFF");
			}
		}
	})

	$('#btnCreateJob').on('click', (e) => {
		e.preventDefault();

		const createJobForm = $('#createJobForm');
		createJobForm.children('input[name=clone]').val('');

		createJobForm.submit();
	});

	const waypoint = new Waypoint({
		element: document.body,
		handler: direction => {
			const actionBar = $('#actionBar');

			if (actionBar) {
				if (direction === 'down') {
					actionBar.addClass('show');
				}

				if (direction === 'up') {
					actionBar.removeClass('show');
				}
			}
		},
		offset: '-200px'
	});

	// Auto Show set drivers modal
	const setDriversModalEl = document.getElementById('setDriversModal');

	if (setDriversModalEl && setDriversModalEl.dataset.show === 'true') {
		const setDriversModal = new bootstrap.Modal(setDriversModalEl);
		setDriversModal.show();
	}

	const driversOffCanvasEl = document.getElementById('driversOffCanvas');

	$('#manageDrivers').on('click', (e) => {
		e.preventDefault();

		// Close Off-canvas drivers list
		if (driversOffCanvasEl) {
			const driversOffCanvas = bootstrap.Offcanvas.getInstance(driversOffCanvasEl);
			driversOffCanvas.hide();

			// Show set drivers modal
			if (setDriversModalEl) {
				const setDriversModal = new bootstrap.Modal(setDriversModalEl);
				setDriversModal.show();
			}

		}
	});


	// Delete docket functionality
	const removeDocketModalEl = document.getElementById('confirmRemoveDocketModal');

	if (removeDocketModalEl) {

		removeDocketModalEl.addEventListener('show.bs.modal', event => {
			const {relatedTarget, currentTarget} = event;
			const docketId = $(relatedTarget).data('id');
			const form = $(currentTarget).find('form');
			const formAction = `/job/dockets/${docketId}/delete/`;

			form.attr('action', formAction);
			$('#removeDocket').removeAttr("disabled");

		});

		removeDocketModalEl.addEventListener('hidden.bs.modal', event => {
			const {currentTarget} = event;
			const form = $(currentTarget).find('form');

			form.attr('action', '');
			$('#removeDocket').attr('disabled', true);
		});
	}

	// Toggle driver respond to job reminders
	$('#subContractorsTable').on('click', '.toggleDriverReminders, .toggleDocketUploadedReminders', async (e) => {
		const {currentTarget} = e;
		const el = $(currentTarget);
		const id = el.data('id');
		const value = el.data('value') !== true;
		const action = el.data('action');


		// Make Ajax request
		const response = await api[action](id, value, this);

		if (!response.error) {
			const {body: {respond_to_job_reminders, docket_notifications}} = response;

			if (action === 'toggleDriverReminders') {
				el.data('value', respond_to_job_reminders);
			}

			if (action === 'toggleDocketUploadedReminders') {
				el.data('value', docket_notifications);
			}

			if (
				(action === 'toggleDriverReminders' && respond_to_job_reminders) ||
                (action === 'toggleAdminNotifications' && docket_notifications)
			) {
				el.addClass('active');
			} else {
				el.removeClass('active');
			}

		}

	});

	// Allow Jobs to be re-ordered
	const jobsList = document.getElementById('jobs');

	if (jobsList) {
		const sortable = Sortable.create(jobsList, {
			handle: '.card__drag',
			animation: 150,
			onUpdate: async (evt) => {
				await api.updateJobOrder(this);
			}
		});
	}


	// Ready to invoice Modal
	const readyToInvoiceModalEl = document.getElementById('readyToInvoiceModal');

	if (readyToInvoiceModalEl) {
		readyToInvoiceModalEl.addEventListener('show.bs.modal', async (e) => {
			const {relatedTarget, currentTarget} = e;
			const jobId = $(relatedTarget).data('id');
			const jobNumber = $(relatedTarget).data('job-no');
			const form = $(currentTarget).find('form');
			const jobNumberEl = $(currentTarget).find('.job-number');
			const jobNumberInput = $('#jobNumberInput');
			const formAction = `/job/${jobId}/ready-to-invoice/`;

			jobNumberInput.on('keyup', (e) => {
				const {currentTarget} = e;
				const el = $(currentTarget);
				const value = el.val().trim();

				if (value === jobNumber) {
					const submitBtn = $(currentTarget).closest('form').find('button[type=submit]');
					submitBtn.removeAttr('disabled');
				}
			});

			jobNumberEl.text(jobNumber);

			form.attr('action', formAction);
		});

		readyToInvoiceModalEl.addEventListener('hidden.bs.modal', event => {
			const {relatedTarget, currentTarget} = event;
			const form = $(currentTarget).find('form');
			const jobNumberEl = $(currentTarget).find('.job-number');
			const jobNumberInput = $('#jobNumberInput');
			const submitBtn = $(form).find('button[type=submit]');

			form.attr('action', '');
			jobNumberEl.text('');
			jobNumberInput.val('');
			submitBtn.attr('disabled', true);
		});
	}

	// Ready to invoice Modal
	const invoiceNumberModalEl = document.getElementById('invoiceNumberModal');

	if (invoiceNumberModalEl) {
		invoiceNumberModalEl.addEventListener('show.bs.modal', async (e) => {
			const {relatedTarget, currentTarget} = e;
			const form = $(currentTarget).find('form');
			const jobId = $(relatedTarget).data('id');
			const jobNumber = $(relatedTarget).data('job-no');
			const jobNumberEl = $(currentTarget).find('.job-number');
			const invoiceNumberInput = $('#invoiceNumberInput')
			const formAction = `/job/${jobId}/invoiced/`;

			invoiceNumberInput.on('keyup', (e) => {
				const {currentTarget} = e;
				const el = $(currentTarget);
				const value = el.val().trim();

				// Check length of value > 2
				if (value.length > 2) {
					const submitBtn = $(currentTarget).closest('form').find('button[type=submit]');
					submitBtn.removeAttr('disabled');
				}
			});

			form.attr('action', formAction);
			jobNumberEl.text(jobNumber);
		});

		invoiceNumberModalEl.addEventListener('hidden.bs.modal', event => {
			const {relatedTarget, currentTarget} = event;
			const form = $(currentTarget).find('form');
			const jobNumberEl = $(currentTarget).find('.job-number');
			const invoiceNumberInput = $('#invoiceNumberInput');
			const submitBtn = $(form).find('button[type=submit]');

			form.attr('action', '');
			jobNumberEl.text('');
			invoiceNumberInput.val('');
			submitBtn.attr('disabled', true);
		});
	}

	$('a[href="#jobToggleDraft"]').on('click', async (e) => {
		e.preventDefault();

		const id = $(e.currentTarget).data('id');
		const date = $(e.currentTarget).data('date');
		const is_draft = JSON.parse($(e.currentTarget).data('is-draft'));

		const response = await api.setJobDraft(id, !is_draft, this);
		const {body: {is_draft: draft}} = response;

		if (draft) {
			window.location.href = '/jobs/drafts/';
		} else {
			window.location.href = `/?date=${date}`;
		}
	});

	// Listen for changes to select id = id_facility if it exists
	const facilitySelect = document.getElementById('id_facility');

	if (facilitySelect) {
		facilitySelect.addEventListener('change', (e) => {
			const {currentTarget} = e;
			const facilityId = $(currentTarget).val();

			// Set the data attr on the jobForm
			document.getElementById('jobForm').setAttribute('data-facility', facilityId);
		});
	}

	// Show confirm dialogue when toggling Requires Invoice
	const requiresInvoiceToggle = document.getElementById('toggleInvoiceRequired');

	if (requiresInvoiceToggle) {
		requiresInvoiceToggle.addEventListener('click', (e) => {
		// Prevent the switch from changing its state immediately
		e.preventDefault();

		// Store the desired state change
		let pendingChange = e.target.checked;

		// Show the confirm modal
		const confirmModalEl = document.getElementById('confirmModal');
		const confirmBtn = confirmModalEl.querySelector('#confirm');

		if (confirmModalEl) {
			const confirmModal = new bootstrap.Modal(confirmModalEl);

			// Get the title el of the modal and set the text modal body h3
			const modalTitle = confirmModalEl.querySelector('.modal__title');
			const modalMessage = confirmModalEl.querySelector('.modal__message');
			const status = pendingChange ? 'YES' : 'NO';

			// Set the text of the modal title
			modalTitle.textContent = 'Please confirm';
			modalMessage.innerHTML = `Are you sure you want to change the Requires Invoice to <b>${status}</b>?`;

			confirmModal.show();

			// Handle the confirmation action
			confirmBtn.addEventListener('click', () => {
				if (pendingChange !== null) {
					// Apply the change
					requiresInvoiceToggle.checked = pendingChange;
				}

				// Reset the flag
				pendingChange = null;

				// Hide the modal
				confirmModal.hide();
			});
		}

		// Listen for the confirm modal to be hidden
		confirmModalEl.addEventListener('hidden.bs.modal', (e) => {
			const modalTitle = confirmModalEl.querySelector('.modal__title');
			const modalMessage = confirmModalEl.querySelector('.modal__message');

			modalTitle.textContent = '';
			modalMessage.innerHTML = '';

		});

		});
	}

});

$(window).resize(() => {

});

